import { AxiosError } from 'axios'
import apiErrorUtil from '../libs/errors/apiErrorUtil'
import { setErrorProcessor } from './useError'

setErrorProcessor((err: AxiosError) => apiErrorUtil.getFormattedApiError(err))
